import React from "react";
import classNames from "classnames";
import styles from "./phoneIcon.css";

interface Props {
  disabled?: boolean;
}

export const PhoneIcon = ({ disabled }: Props) => (
  <div className={classNames(styles.container, { [styles.disabled]: disabled })}>
    <i className={classNames("icon-phone", styles.icon)} />
  </div>
);
